import React from 'react';
import { noop } from 'lodash';

import { FlagHandler } from './types';

export const SelectIsOpenContext = React.createContext<FlagHandler>(noop);
